import { defineMessages } from 'react-intl';

export default defineMessages({
    emptyAmount: {
        id: 'ent.offerdetails.makeapayment.Empty Amount',
        defaultMessage: '-',
    },
    vendorFee: {
        id: 'ent.offerdetails.makeapayment.Vendor Fee Label',
        defaultMessage: "Estimated Vendor Fee:"
    },
    vendorFeeWithRate: {
        id: 'ent.offerdetails.makeapayment.Vendor Fee Label With Rate',
        defaultMessage: "Estimated Vendor Fee ({feeRate}%):"
    },
    tbd: {
        id: 'twia.policy.common.views.account-offer-details.TBD',
        defaultMessage: "TBD"
    },
    errorInProcessingPayment: {
        id: 'twia.billing.directives.templates.payment-instruments.Error in processing the payment',
        defaultMessage: 'Error in processing the payment'
    },
    paymentSystemUnavailable: {
        id: 'twia.policy.common.views.aci.Payment System Unavailable.Title',
        defaultMessage: 'Payment System Unavailable'
    },
    paymentSystemUnavailbleBody: {
        id: 'twia.policy.common.views.aci.Payment System Unavailable.Body',
        defaultMessage: 'The online payment system is currently unavailable. Please check back later.'
    },
    cardDeclinedTitle: {
        id: 'twia.policy.common.views.account-offer-details.Card Declined Title',
        defaultMessage: 'Your Card was Declined'
    },
    cardDeclinedBody:{
        id: 'twia.policy.common.views.account-offer-details.Card Declined Body',
        defaultMessage: 'Please verify your card information. If the problem persists, please contact your card issuer.'
    },
    duplicatePaymentNotProcessedBody: {
        id:'twia.policy.common.views.account-offer-details.Duplicate Payment Not Processed Body',
        defaultMessage:'A transaction for this amount {amount} was already processed today'
    },
    unableToCompletePaymentTitle: {
        id: 'twia.policy.common.views.account-offer-details.Unable To Complete Payment Title',
        defaultMessage: 'Your Payment Cannot Be Processed'
    },
    unableToCompleteBody: {
        id: 'twia.policy.common.views.account-offer-details.Unable To Complete Payment Body',
        defaultMessage: 'Please try again later'
    },
    confirmAutoPayTitle: {
        id: 'twia.policy.common.views.account-offer-details.Confirm Auto Pay Title',
        defaultMessage: 'Confirm Auto Pay?'
    },
    confirmAutoPayDescription: {
        id: 'twia.policy.common.views.account-offer-details.Confirm Auto Pay Description',
        defaultMessage: 'By confirming Auto Pay, you are authorizing us to draft due and past due invoices directly from your account.'
    },
});
